/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

'use client';

import type { ReactNode } from 'react';

import {
  Page,
  PageContents,
  PageContentsSection,
  PageContentsSpacer,
} from '@marketplace/gather-ui/layouts';

import CatalogVehiclesLoadingView from './views/catalog-vehicles-loading.view';

export default function Loading(): ReactNode {
  return (
    <Page>
      <PageContents fullHeight>
        <PageContentsSpacer spacing={{ base: 4, sm: 6 }} />
        <PageContentsSection fullHeight direction='row'>
          <CatalogVehiclesLoadingView />
        </PageContentsSection>
      </PageContents>
    </Page>
  );
}
